import React from 'react';
import { Link } from 'react-router-dom';
import styles from './App.css'; // Adjust the path as needed
import main from './11.png';
import Torah from './2.png'
import Game from './1.png'
import Shop from './shop.png'

const Menu = () => {
  return (
    <header className={styles.header}>
      <div className={styles.socialLinks}>
      <Link to="/">
          <img src={main} alt="main" width={370} height={100} />
        </Link>
        <Link to="/torah-tools">
          <img src={Torah} alt="Torah" width={165} height={100} />
        </Link>
        <Link to="/Game">
          <img src={Game} alt="Game" width={165} height={100} />
        </Link>
        <Link to="/Shop">
          <img src={Shop} alt="Shop" width={165} height={100} />
        </Link>
      </div>
    </header>
  ); 
};

export default Menu;

